// extracted by mini-css-extract-plugin
module.exports = {"sectionTitle":"df2f2__common-module__section-title"};